module.exports = "<div class=\"switch-files\">\n  <a class=\"nav-link p-0\" (click)=\"switchView(ViewType.Tile)\" [class.active]=\"fileView === ViewType.Tile\">\n    <!-- TODO placeholder icon -->\n    <span><i class=\"icon icon-grid-view\" aria-hidden=\"true\"></i></span>\n  </a>\n  <a class=\"nav-link p-0 ml-2\" (click)=\"switchView(ViewType.Row)\" [class.active]=\"fileView === ViewType.Row\">\n    <span><i class=\"icon icon-list-view\" aria-hidden=\"true\"></i></span>\n  </a>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/switch-files/switch-files.component.html
// module id = ./src/app/shared/components/switch-files/switch-files.component.html
// module chunks = main